
document.addEventListener('DOMContentLoaded', function () {
  const openBtn = document.querySelector('[data-mobile-open]');
  const closeBtn = document.querySelector('[data-mobile-close]');
  const drawer = document.querySelector('[data-mobile-drawer]');
  const overlay = document.querySelector('[data-mobile-overlay]');
  const toggle = (open) => {
    if (!drawer || !overlay) return;
    drawer.classList.toggle('is-open', open);
    overlay.classList.toggle('is-open', open);
    document.body.classList.toggle('no-scroll', open);
  };
  if (openBtn) openBtn.addEventListener('click', () => toggle(true));
  if (closeBtn) closeBtn.addEventListener('click', () => toggle(false));
  if (overlay) overlay.addEventListener('click', () => toggle(false));
});
